__turbopack_context__.v({
  "backBtnStyles": "TyF_7q_backBtnStyles",
  "container": "TyF_7q_container",
  "title": "TyF_7q_title",
});
